import { Button } from "@material-ui/core";
import React, { useState } from "react";

import { ScheduledJob } from "../../../../dtos/scheduledJob";
import { ScheduledJobType } from "../../../../enums/ScheduledJobType";

import { AddScheduledJobDialog } from "./Dialog";

interface Props {
    onJobAdded: (job: ScheduledJob) => void;
    availableJobTypes: ScheduledJobType[];
}

export function AddScheduledJobButton({ onJobAdded, availableJobTypes }: Props) {
    const [openDialog, setOpenDialog] = useState(false);

    return <>
        <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
            style={{ marginBottom: "10px" }}
            disabled={availableJobTypes.length === 0}
        >
            Add New Job
        </Button>

        <AddScheduledJobDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onJobAdded={(job) => {
                setOpenDialog(false);
                onJobAdded(job);
            }}
            availableJobTypes={availableJobTypes}
        />
    </>;
}